<template>
    <card v-bind="cardProps" :to="$web('events.participations.show', [event._key, participation._key])" :style="{borderTop: `2px solid ${displayColor}`}" class="z-1">
        <card-image :src="participation.avatar_thumbnail" :size="{ratio: 1, width: 192, sm: {width: 208}, lg: {width: 192}}">
            <div v-if="participation.club && participation.club.avatar_thumbnail" class="absolute bottom-0 right-0 m-8">
                <avatar :model="participation.club" :size="32"/>
            </div>
        </card-image>
        <div class="flex flex-column items-start px-12 md:px-16 py-8 w-full overflow-x-hidden">
            <div class="flex w-full overflow-x-hidden mb-1">
                <slot name="subtitle"/>
                <meta-text v-if="participation.club" :color="participation.club.color ?? $config.public.colors.primary" xx-small>{{ participation.club.display_name }}</meta-text>
            </div>

            <p class="font-heading text-xs leading-spaced font-bold text-heading-color mb-0 truncate w-full">{{ participation.display_name }}</p>

        </div>
    </card>
</template>

<script>
import {CardMixin} from "@spoferan/nuxt-spoferan/mixins";

export default {
    name: "ParticipationCard",

    mixins: [CardMixin],

    props: {
        participation: {
            type: Object,
            required: true
        },

        event: {
			type: Object,
			required: true
        },
    },

    computed: {
        displayColor() {
            return this.event.color ?? this.$config.public.colors.primary;
        }
    }
}
</script>